module.exports = __webpack_public_path__ + "static/img/Kunpeng_Chair.e060ead6.png";